
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salaryJobPage",
      function () {
        return require("private-next-pages/salaryJobPage.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salaryJobPage"])
      });
    }
  